import { defineComponent as r, computed as d } from "vue";
import s from "./td-longtail-vue-components10.js";
import a from "./td-longtail-vue-components6.js";
const l = /* @__PURE__ */ r({
  __name: "prices",
  props: {
    theme: { default: void 0 },
    variant: { default: void 0 },
    preTextIsPrice: { default: void 0 },
    postTextIsPrice: { default: void 0 },
    preTextWasPrice: { default: void 0 },
    postTextWasPrice: { default: void 0 },
    title: { default: void 0 },
    isPrice: { default: void 0 },
    wasPrice: { default: void 0 },
    isPriceBold: { type: Boolean },
    isWasPriceBold: { type: Boolean }
  },
  setup(i, { expose: o }) {
    const e = i, t = d(() => {
      if (e.theme)
        return `prices--${e.theme}`;
    });
    return o({ themeClass: t }), { __sfc: !0, props: e, themeClass: t, Price: s, Heading: a };
  }
});
export {
  l as default
};
